import { NgModule } from '@angular/core';
import { QuillEditorModule } from 'ngx-quill-editor';
import { SharedModule } from '../shared/shared.module';
import { BookComponent } from './book.component';
import { BookEditComponent } from './book-edit/book-edit.component';
import { BookFormComponent } from './shared/book-form/book-form.component';
import { BookService } from './shared/book.service';
import { FormsService } from '../shared/forms.service';
import { BookSyncComponent } from "./book-sync/book-sync.component";
import {BookSendComponent} from "./book-send/book-send.component";
import {SelectedUserListComponent} from "./book-send/first-step/selected-user-list/selected-user-list.component";
import {SelectedBookListComponent} from "./book-send/first-step/selected-book-list/selected-book-list.component";
import {MailDetailsComponent} from "./book-send/second-step/mail-details.component";
import {BookSendService} from "./book-send/book-send.service";

@NgModule({
  imports: [
    SharedModule,
    QuillEditorModule,
  ],
  providers: [
    BookService,
    FormsService,
    BookSendService
  ],
  declarations: [ BookComponent, BookEditComponent, BookFormComponent, BookSyncComponent, BookSendComponent,
    SelectedUserListComponent, SelectedBookListComponent, MailDetailsComponent]
})
export class BookModule { }



// WEBPACK FOOTER //
// ./src/app/book/book.module.ts